var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 5.82001C15.9164 5.03963 15.5397 4.03744 15.54 3.00001H12.45V15.4C12.4262 16.071 12.1429 16.7066 11.6598 17.1729C11.1767 17.6393 10.5315 17.8999 9.86001 17.9C8.44001 17.9 7.26001 16.74 7.26001 15.3C7.26001 13.58 8.92001 12.29 10.63 12.82V9.66001C7.18001 9.20001 4.16001 11.88 4.16001 15.3C4.16001 18.63 6.92001 21 9.85001 21C12.99 21 15.54 18.45 15.54 15.3V9.01001C16.793 9.90986 18.2974 10.3927 19.84 10.39V7.30001C19.84 7.30001 17.96 7.39001 16.6 5.82001Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTiktok);
export default __webpack_public_path__ + "static/media/icon-tiktok.93c9be6904d0d610bc8281cb3fe26b98.svg";
export { ForwardRef as ReactComponent };